import { registerCrudStore } from '@/libs/core/+state/register-crud-store';
import { NotificationModel } from '@/libs/Api';
import { NotificationsDataService } from '@/libs/notifications/notifications-data-service';
import { BusinessModule } from '@/libs/core/models/business-module';

export const notificationsStore = registerCrudStore<NotificationModel, NotificationModel>(BusinessModule.Notification, new NotificationsDataService());
